export default "__VITE_ASSET__CgjYxe6d__"